module.exports = "/static/js/d4931b563d9c6951dbf1996d346d58bb.png";